import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalOverlayRef } from '@core/classes/modal-overlay.ref';
import { EmailService } from '@core/services/email.service';
import { LoginService } from '@core/services/login.service';
import { UiService } from '@core/services/ui.service';
import { Store } from '@ngrx/store';
import { AppState } from '@redux/app.reducers';
import { getFieldError, isFieldInvalid, isFieldValid } from '@shared/utils/forms/validations.util';
import { Subscription } from 'rxjs';
import { DialogComponent } from '../dialog/dialog.component';

@Component({
  selector: 'mfp-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss']
})
export class ShareComponent implements OnInit, OnDestroy {
  $storeSubscription!: Subscription;
  lifePlanId = '';
  lifePlanTitle = '';
  shareForm: FormGroup;

  isFieldValid = isFieldValid;
  isFieldInvalid = isFieldInvalid;
  getFieldError = getFieldError;

  constructor(
    public dialogRef: ModalOverlayRef,
    private loginService: LoginService,
    private store: Store<AppState>,
    private formBuilder: FormBuilder,
    private emailService: EmailService,
    private uiService: UiService,
    private router: Router
  ) {
    this.shareForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit() {
    this.$storeSubscription = this.store.subscribe({
      next: state => {
        this.lifePlanId = String(state.lifePlan.currentLifePlan.id);
        this.lifePlanTitle = String(state.lifePlan.currentLifePlan.title);
      }
    });
  }

  ngOnDestroy() {
    this.$storeSubscription.unsubscribe();
  }

  onSendForm() {
    this.sendAgentLifePlan();
  }

  onCloseModal() {
    this.dialogRef.close();
  }

  private sendAgentLifePlan() {
    this.shareForm.markAllAsTouched();
    if (this.shareForm.valid) {
      this.uiService.presentLoading('Enviando planificación...');
      const recipientEmail = this.shareForm.get('email')?.value;
      this.emailService.sendAgentLifePlan(this.lifePlanId, this.lifePlanTitle, recipientEmail).subscribe({
        next: response => {
          this.onCloseModal();
          this.router.navigateByUrl('/agent/life-plans');
          this.uiService.openModal(
            DialogComponent,
            {
              hasBackdrop: true,
              position: 'center'
            },
            {
              type: 'success',
              title: 'Enviada',
              text: 'Se ha enviado la planificación correctamente',
              successAction: 'Aceptar',
              cancelAction: ''
            }
          );
        },
        error: error => {
          this.uiService.dismissLoading();
          this.uiService.openErrorModal();
        },
        complete: () => this.uiService.dismissLoading()
      });
    }
  }
}
